import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { FeatureFlagFacade } from '@rx-applications/shared/clientsite/feature-flags';

export const CustomFieldFeatureFlagGuard: CanMatchFn = () => {
  const featureFlagFacade = inject(FeatureFlagFacade);
  return featureFlagFacade.enableSelfCustomFieldEnabled$;
};
